// Operation handover acknowledgement (backend djangoapp/urls_ack.py, mounted under /bp/).
//   The batch's GENERAL instructions are no longer read and signed (19 Oct 2026): what a person reads before
//   executing is the instruction of the PROCESS, set on the process itself.
import Axios from 'axios';

const bp = '/bp';

const plantId = () => {
  try {
    const p = JSON.parse(localStorage.getItem('active-plant') || 'null');
    return p?.id || null;
  } catch (e) {
    return null;
  }
};

const headers = () => ({
  Authorization: `Bearer ${localStorage.getItem('Token')}`,
  'Content-Type': 'application/json',
  Accept: 'application/json',
});

/** Resolves to the response body; a failed request resolves to its error body (+ `httpStatus`) instead of throwing. */
const unwrap = (p) =>
  p
    .then((r) => ({ ...(r.data || {}), httpStatus: r.status }))
    .catch((e) => ({ status: 'failed', message: e?.message || 'Network error', ...(e?.response?.data || {}), httpStatus: e?.response?.status || 0 }));

const get = (url, params = {}) => unwrap(Axios.get(`${bp}${url}`, { params: { plant_id: plantId(), ...params }, headers: headers() }));
const post = (url, body = {}) => unwrap(Axios.post(`${bp}${url}`, { plant_id: plantId(), ...body }, { headers: headers() }));
const put = (url, body = {}) => unwrap(Axios.put(`${bp}${url}`, { plant_id: plantId(), ...body }, { headers: headers() }));

/** A person's first action on an operation that requires a handover acknowledgement (operation start or a reading). */
export const isHandoverAckRequired = (res) => res?.code === 'HANDOVER_ACK_REQUIRED';

export const ackApi = {
  //   GET  /bp/batch/<bn>/operations/<op>/handover/     the operation's handover note + required/acknowledged for me
  //   POST /bp/batch/<bn>/operations/<op>/acknowledge/  {esign} → e-signed handover acknowledgement (per person, per operation)
  operationHandover: (batchNumber, operationId) => get(`/batch/${encodeURIComponent(batchNumber)}/operations/${operationId}/handover/`),
  acknowledgeHandover: (batchNumber, operationId, esign, stationCode) =>
    post(`/batch/${encodeURIComponent(batchNumber)}/operations/${operationId}/acknowledge/`, { esign, ...(stationCode ? { station_code: stationCode } : {}) }),
  // 2026-10-21 (owner) · the MBMR's general instructions are back: written on the MBMR (create / Edit MBMR),
  // shown on the tablet MERGED with each process's own instruction before its first step.
  //   GET/PUT /bp/recipe/<id>/instructions/   · POST …/copy/ {recipe_ids}
  recipeInstructions: (recipeId) => get(`/recipe/${recipeId}/instructions/`),
  saveRecipeInstructions: (recipeId, body) => put(`/recipe/${recipeId}/instructions/`, body),
  copyRecipeInstructions: (recipeId, recipeIds) => post(`/recipe/${recipeId}/instructions/copy/`, { recipe_ids: recipeIds }),
  /** Legacy execution endpoints called through axios so a 428 body (handover) is returned instead of swallowed. */
  saveBatchParameters: (body) => post('/bp_save_batch_parameters', body),
  startOperation: (body) => post('/start_operation_manual', body),
};

export default ackApi;
